/**
 * 404 Not Found page.
 */

export function NotFoundPage(): HTMLElement {
  const page = document.createElement('div');
  page.className = 'not-found-page';
  page.innerHTML = `
    <div class="not-found-container">
      <h1 class="not-found-code">404</h1>
      <h2 class="not-found-title">Page not found</h2>
      <p class="not-found-desc">The page you're looking for doesn't exist or has been moved.</p>
      <a href="#/dashboard" class="btn btn-primary">Go to Dashboard</a>
    </div>
  `;
  return page;
}
